/**
 * Every antd date box on a phone (2026-11-02, the owner): tapping it scrolls the page so the box sits just under the top bar,
 * and its calendar opens right below it. Left alone, the popup ran off the side, or flipped up behind the bar with its month
 * and arrows hidden. Installed once, so the 30-odd pages with a date box need nothing of their own. The styles are in
 * index.scss. On a screen too short for box and calendar together the calendar moves up, so it is always seen whole.
 */
const PHONE = "(max-width: 767.95px)";
const OPEN_POPUP = ".ant-picker-dropdown:not(.ant-picker-dropdown-hidden)";
const GAP = 12;
const EDGE = 8;

export const installPhoneDatePicker = () => {
  let box = null;
  const isPhone = () => !!window.matchMedia && window.matchMedia(PHONE).matches;

  // Follows the box, so the calendar stays under it if the page moves.
  const placeCalendar = () => {
    const popup = box && document.querySelector(OPEN_POPUP);
    if (!popup) return;
    const below = box.getBoundingClientRect().bottom + GAP;
    const lowest = window.innerHeight - EDGE - popup.offsetHeight;
    const top = Math.max(EDGE, Math.min(below, lowest));
    document.documentElement.style.setProperty("--date-popup-top", `${top}px`);
  };

  const bringUp = () => {
    if (!box || !document.querySelector(OPEN_POPUP)) return;
    if (box.scrollIntoView) box.scrollIntoView({ block: "start" });
    placeCalendar();
  };

  const onBox = (event) => {
    const target = event.target;
    const found = target && target.closest ? target.closest(".ant-picker") : null;
    if (!found || !isPhone()) return;
    box = found;
    // The dates are picked on the calendar: the phone's keyboard would only cover it.
    box.querySelectorAll("input").forEach((input) => {
      input.readOnly = true;
    });
    // The calendar opens just after this event, and the page gets its extra room to scroll (index.scss) when it does.
    requestAnimationFrame(bringUp);
    setTimeout(bringUp, 80);
    setTimeout(placeCalendar, 300);
  };

  document.addEventListener("pointerdown", onBox, true);
  document.addEventListener("focusin", onBox, true);
  window.addEventListener("scroll", placeCalendar, { passive: true, capture: true });
  window.addEventListener("resize", placeCalendar);

  return () => {
    document.removeEventListener("pointerdown", onBox, true);
    document.removeEventListener("focusin", onBox, true);
    window.removeEventListener("scroll", placeCalendar, { capture: true });
    window.removeEventListener("resize", placeCalendar);
  };
};
